import csrfToken from "../../common/helpers/csrf-token";
import * as EventListener from "../../common/helpers/event-listener";

const updateRating = () => {
    EventListener.click("product-rating-radio", (radio) => {
        const offerId = radio.getAttribute("data-offer-id");
        const ratingRadios = document.querySelectorAll(".product-rating-radio");

        ratingRadios.forEach((radio) => {
            radio.disabled = true;
        });

        oc.ajax("ProductPage::onUpdateRating", {
            data: {
                _token: csrfToken,
                rating: radio.value,
                offer_id: offerId,
            },
            loading: "#loader-line",
            update: {
                "catalog/product-page/rating": ".rating-info-wrapper",
            },
            complete: () => {
                radio.disabled = false;

                ratingRadios.forEach((radio) => {
                    radio.disabled = false;
                });
            },
        });
    });
};

updateRating();
